import { generalCategoryContactList, generalCategoryContactListLead, teamMemberRolesList } from 'constants/automation';
import { generateFullName } from 'utils/generateFullNameUtils';

export const formatUserDropdown = ({
  users = [],
  isLead = false,
  includesFirmUsers = true,
  includesUserGroups = true,
  includesTeamMembers = true,
  includeContacts = true,
  hideInactive = false,
  includePrimarySecondary = false,
}) => {
  let formattedUserGroups = {
    groupLabel: 'User Groups',
    code: 'User Groups',
    items: [],
  };
  let formattedFirmUsers = {
    groupLabel: 'Users',
    code: 'Users',
    items: [], //Primary and Billing contact list
  };
  let formattedTeamMemberRoles = {
    groupLabel: 'Team Member Roles',
    code: 'Team Members',
    items: [...teamMemberRolesList],
  };

  let formattedContacts = {
    groupLabel: 'Contacts',
    code: 'Contacts',
    items: [],
  };

  if (includePrimarySecondary) {
    formattedFirmUsers.items = [...(isLead ? generalCategoryContactListLead : generalCategoryContactList)];
  }

  if (users?.length) {
    users.forEach((user) => {
      if (user?.res_type === 'user') {
        if (user?.status !== 'ACTIVE' && hideInactive) return;
        formattedFirmUsers.items.push({
          label: generateFullName(user) || '',
          value: user?.firm_user_id,
          is_confirmed: user?.is_confirmed,
          status: user?.status,
          firm_user_id: user?.firm_user_id,
          res_type: user?.res_type,
        });
      } else if (user?.res_type === 'user-group') {
        if (user?.status === 'ARCHIVED' && hideInactive) return;
        formattedUserGroups.items.push({
          label: user?.group_name || '',
          value: user?.user_group_id,
          res_type: user?.res_type,
          status: user?.status,
        });
      } else if (user?.res_type === 'contact') {
        formattedContacts.items.push(user);
      }
    });
  }

  const result = [];
  if (includesFirmUsers) result.push(formattedFirmUsers);
  if (includesTeamMembers) result.push(formattedTeamMemberRoles);
  if (includesUserGroups) result.push(formattedUserGroups);
  if (includeContacts) result.push(formattedContacts);
  return result;
};
